interface ICustomImage {
  alt?: string;
  className?: string;
  fit?: string;
  height?: number;
  isPresentation?: boolean;
  png?: boolean;
  src: string;
  width?: number;
  dataTestid?: string;
}

const CustomImage = ({
  alt,
  className,
  fit,
  height,
  isPresentation,
  png,
  src,
  width,
  dataTestid,
}: ICustomImage) => {
  const isBase64 = src.indexOf('data:image') > -1 && src.indexOf('base64') > -1;

  if (!src) {
    return null;
  }
  let link = `${src}`;
  if (!isBase64 && (src.startsWith('//') || !src.startsWith('http'))) {
    link = `https://${link.replace(/^\/+/, '')}`;
  }

  if (!src.includes('hurtigruten')) {
    if (!src.endsWith('?')) {
      link += '?';
    }
    link += `w=${width || 1200}&h=${height || 1200}&fit=${fit || 'thumb'}&fm=${
      png ? 'png' : 'jpg&fl=progressive'
    }&q=80`;
  }

  return (
    <img
      src={link}
      className={className}
      alt={alt || undefined}
      role={isPresentation ? 'presentation' : undefined}
      data-testid={dataTestid}
    />
  );
};

export default CustomImage;
